module.exports = __webpack_public_path__ + "static/media/bg5.056eb058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg5.jpg
// module id = 988
// module chunks = 0